'use client';
import { ApolloClient, ApolloProvider, InMemoryCache } from '@apollo/client';
import { SessionProvider } from 'next-auth/react';
import { Provider as JotaiProvider } from 'jotai';
import LDProviderWrapper from '@/lib/LDClient';

const client = new ApolloClient({
  cache: new InMemoryCache(),
  uri: '/graphql',
});

export const Providers = ({
  children,
  clientSideID,
  session,
}: {
  children: React.ReactNode;
  clientSideID: string;
  session?: any;
}) => {
  return (
    <SessionProvider>
      <LDProviderWrapper clientSideID={clientSideID} session={session}>
        <ApolloProvider client={client}>
          <JotaiProvider>{children}</JotaiProvider>
        </ApolloProvider>
      </LDProviderWrapper>
    </SessionProvider>
  );
};
